import Phaser from "phaser";
import { gameVM } from "../Game.jsx";
import { dispatchChangeScene } from "../reducers/sceneReducer";
import emitter from "../Events/EventManager";
import { QUIT_GAME2, RESTART_GAME } from "../Events/Events";
import UI from "../../Utils/UI/UI";

//TC Version
// import background from "../assets/game-background.png";
// import timeFont from "../assets/game-timefont.png";
// import scoreFont from "../assets/game-marksfont.png";
// import timerBar from "../assets/game-timebar.png";
// import gameScorebar from "../assets/game-marksbar.png";
// import timeProgressbar from "../assets/game-timer.png";
// import goToInstruction from "../assets/game-gameinfobutton.png";

// import understand from "../assets/game-gameinfobutton2.png";
// import leftDoor from "../assets/game-Ldoor.png";
// import rightDoor from "../assets/game-Rdoor.png";
import scoreBoard from "../assets/game-endgame.png";
import restartButton from "../assets/game-endgamebutton.png";
import restartFromBeginning from "../assets/game-endgamebutton2.png";
// import quitButton from "../assets/game-quitbutton.png";

//EN Version
// import backgroundEN from "../assets/EN/game-background.png";
// import timeFontEN from "../assets/EN/game-timefont.png";
// import scoreFontEN from "../assets/EN/game-marksfont.png";
// import timerBarEN from "../assets/EN/game-timebar.png";
// import gameScorebarEN from "../assets/EN/game-marksbar.png";
// import timeProgressbarEN from "../assets/EN/game-timer.png";
// import goToInstructionEN from "../assets/EN/game-gameinfobutton.png";
// import instructionEN from "../assets/EN/game-gameinfo.png";
// import understandEN from "../assets/EN/game-gameinfobutton2.png";
// import leftDoorEN from "../assets/EN/game-Ldoor.png";
// import rightDoorEN from "../assets/EN/game-Rdoor.png";
import scoreBoardEN from "../assets/EN/game-endgame.png";
import restartButtonEN from "../assets/EN/game-endgamebutton.png";
import restartFromBeginningEN from "../assets/EN/game-endgamebutton2.png";
// import quitButtonEN from "../assets/EN/game-quitbutton.png";

//SC Version
import scoreBoardSC from "../assets/SC/game-endgame.png";
import restartButtonSC from "../assets/SC/game-endgamebutton.png";
import restartFromBeginningSC from "../assets/SC/game-endgamebutton2.png";

export default class Ending extends Phaser.Scene {
  scale;
  UI;
  constructor() {
    super({ key: "Ending" });
    this.scale = 4;
    this.UI = new UI(this);
  }

  preload() {
    dispatchChangeScene("Ending");

    if (gameVM.language == null) {
      this.textures.remove("scoreBoard");
      this.textures.remove("restartFromBeginning");
      this.textures.remove("restartButton");
      this.load.image("scoreBoard", scoreBoard, true);
      this.load.image("restartFromBeginning", restartFromBeginning, true);
      this.load.image("restartButton", restartButton, true);
    } else if (gameVM.language == "EN") {
      this.textures.remove("scoreBoard");
      this.textures.remove("restartFromBeginning");
      this.textures.remove("restartButton");
      this.load.image("scoreBoard", scoreBoardEN, true);
      this.load.image("restartFromBeginning", restartFromBeginningEN, true);
      this.load.image("restartButton", restartButtonEN, true);
    } else if (gameVM.language == "SC") {
      this.textures.remove("scoreBoard");
      this.textures.remove("restartFromBeginning");
      this.textures.remove("restartButton");
      this.load.image("scoreBoard", scoreBoardSC, true);
      this.load.image("restartFromBeginning", restartFromBeginningSC, true);
      this.load.image("restartButton", restartButtonSC, true);
    }
  }

  create() {
    emitter.on(QUIT_GAME2, () => {
      this.quitGame();
      emitter.removeListener("QUIT_GAME2");
    });

    emitter.on(RESTART_GAME, () => {
      emitter.removeListener("RESTART_GAME");
      this.playAgainButton.emit("pointerup");
    });

    this.clickSound = this.sound.add("clickSound");
    this.finishSound = this.sound.add("finishSound");
    this.sound.play("finishSound");

    this.addQuitButton();
    this.add.image(0, 0, "background_scene3").setOrigin(0, 0);
    this.add.image(80, 62, "timeFont");
    this.add.image(365, 62, "timerBar");
    this.add.image(80, 149, "scoreFont");
    this.add.image(268, 149, "gameScorebar");
    this.timeProgressbar = this.add
      .image(190, 42, "timeProgressbar")
      .setOrigin(0, 0);

    this.add.image(0.55 * 1920, 387, "leftDoor");
    this.add.image(0.775 * 1920, 387, "rightDoor");

    this.add.image(0.25 * 1920, 150, "goToInstruction");
    this.add.image(0.934 * 1920, 60, "quitButton");

    this.cropTimeBar();

    this.graphics = this.add.graphics(0, 0);
    this.graphics.fillStyle(0x000000, 0.5);
    this.graphics.fillRect(0, 0, 1920, 1080);

    this.scoreContainer = this.add.container(0, 0);

    this.board = this.add.image(1920 / 2, 0.43 * 1080, "scoreBoard");
    this.fadeIn(this.board);

    this.addScoreTexts();

    this.restartFromBeginningButton = this.UI.Factory.clickableButton(
      "restartFromBeginning",
      0.37,
      0.875,
      () => {
        this.sound.play("clickSound");
        this.quitGame();
      }
    );
    this.playAgainButton = this.UI.Factory.clickableButton(
      "restartButton",
      0.63,
      0.875,
      () => {
        this.sound.play("clickSound");
        gameVM.scene3.scene.stop();
        this.scene.start("Scene3");
      }
    );

    this.fadeIn(this.restartFromBeginningButton);
    this.fadeIn(this.playAgainButton);
  }

  removeTextures() {
    const imgKeys = [
      "background_scene3",
      "timeFont",
      "scoreFont",
      "timerBar",
      "gameScorebar",
      "timeProgressbar",
      "goToInstruction",
      "instruction",
      "understand",
      "leftDoor",
      "rightDoor",
      "scoreBoard",
      "restartFromBeginning",
      "restartButton",
    ];
    for (let key of imgKeys) {
      console.log("scene 4 remove key " + key);
      this.textures.remove(key);
    }
  }

  addButton(ImgKey, X_proportion, Y_proportion, onClickEvent) {
    const button = this.add
      .image(1920 * X_proportion, 1080 * Y_proportion, ImgKey)
      .setInteractive({ cursor: "pointer" });
    button.on(
      "pointerup",
      () => {
        onClickEvent();
      },
      this
    );
    this.fadeIn(button);

    return button;
  }

  addRestartButton() {
    this.restartButton = this.add
      .image(1920 * 0.5, 0.875 * 1080, "restartButton")
      .setInteractive({ cursor: "pointer" });
    this.restartButton.on(
      "pointerup",
      () => {
        this.sound.play("clickSound");
        this.quitGame();
      },
      this
    );
    this.fadeIn(this.restartButton);
  }

  addQuitButton() {
    this.quitButton = this.add.image(0.934 * 1920, 60, "quitButton");
    // .setInteractive({ cursor: "pointer" });
    // this.quitButton.on("pointerup", this.quitGame, this);
    // this.fadeIn(this.quitButton);
  }

  removeTextures() {
    const imgKeys = [
      "background",
      "gameInfo",
      "howToPlay",
      "keyPoint",
      "next",
      "startGame",
      "playInfo",
      "keypoint1",
      "keypoint2",
      "wordsInAdvance",
      "gameBackground",
    ];

    for (let key of imgKeys) {
      this.currentScene.textures.remove(key);
    }
  }

  quitGame() {
    this.scene.stop();
    this.sound.play("clickSound");
    gameVM.scene3.scene.start("Scene1");
    gameVM.scene3.scene.sendToBack();
    gameVM.latestScore = 0;
    gameVM.timeRemaining = gameVM.gameTotalTime;
  }

  addScoreTexts() {
    this.scoreTextSmall = this.add
      .text(264, 147, gameVM.latestScore, {
        fontSize: "70px",
        fill: "#374631",
        fontFamily: "DFZongYi",
      })
      .setScale(1, 0.6)
      .setOrigin(0.5, 0.5);

    this.scoreTextBig = this.add
      .text(0.5 * 1920, 0.48 * 1080, gameVM.latestScore, {
        fontSize: "300px",
        fill: "#46cfaa",
        fontFamily: "DFZongYi",
      })
      .setOrigin(0.5, 0.5)
      .setScale(1 * 2, 0.6 * 2);

    this.fadeIn(this.scoreTextBig);
  }

  cropTimeBar() {
    this.timeProgressbar.setCrop(
      0,
      0,
      (gameVM.timeRemaining / gameVM.gameTotalTime) * 350,
      100
    );
  }

  update() {}

  fadeIn(obj) {
    this.tweens.add({
      targets: obj,
      alpha: { from: 0, to: 1 },
      duration: 500,
    });
  }
}
